import {
    IAcoesReguaEtapa,
    ICadastrarAcaoEtapaBody,
    IDadosReguaEtapa,
    IEtapaAcaoAgendamento,
    IOrdenacaoReguaEtapa,
    IRegua,
    IReguaEtapa,
    IReguaEtapaAcaoFiltro,
    IReguaEtapaAcaoTipoFiltro,
    IServicosSMS,
    ITipoAcaoRegua,
} from "../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function ValidarReguaServices(IdRegua: number) {
    return Service(
        Axios.post(`/automacao/regua/validarregua?IdRegua=${IdRegua}`)
    );
}

export async function DesvalidarReguaServices(IdRegua: number) {
    return Service(
        Axios.post(`/automacao/regua/desvalidarregua?IdRegua=${IdRegua}`)
    );
}

export async function DeletarReguaServices(IdRegua: number) {
    return Service(
        Axios.delete(
            `/automacao/regua/deletarregua?idCasoCobrancaRegua=${IdRegua}`
        )
    );
}

export async function AtualizarReguaServices(requestBody: IRegua) {
    return Service(Axios.put(`/automacao/regua/atualizarregua`, requestBody));
}

export async function ListarReguaService() {
    return Service(Axios.get<Array<IRegua>>(`/automacao/regua/listarreguas`));
}

export async function CadastrarReguaServices(requestBody: IRegua) {
    return Service(Axios.post(`/automacao/regua/cadastrarregua`, requestBody));
}

export async function ListarServicosSMSService() {
    return Service(
        Axios.get<Array<IServicosSMS>>(`/automacao/regua/listarservicosms`)
    );
}

export async function GetReguaService(idCasoCobrancaRegua: number) {
    return Service(
        Axios.get<IRegua>(
            `/automacao/regua/getregua?idCasoCobrancaRegua=${idCasoCobrancaRegua}`
        )
    );
}

export async function ListarReguaEtapaService(idCasoCobrancaRegua: number) {
    return Service(
        Axios.get<Array<IReguaEtapa>>(
            `/automacao/regua/listarreguaetapa?idCasoCobrancaRegua=${idCasoCobrancaRegua}`
        )
    );
}

export async function GetReguaEtapaService(idEtapaRegua: number) {
    return Service(
        Axios.get<IReguaEtapa>(
            `/automacao/regua/getreguaetapa?idEtapaRegua=${idEtapaRegua}`
        )
    );
}

export async function AtualizarEtapaReguaService(requestBody: IReguaEtapa) {
    return Service(
        Axios.put(`/automacao/regua/atualizaretaparegua`, requestBody)
    );
}

export async function CadastrarEtapaReguaService(requestBody: IReguaEtapa) {
    return Service(
        Axios.post(`/automacao/regua/cadastraretaparegua`, requestBody)
    );
}

export async function DeletarEtapaReguaService(idEtapaRegua: number) {
    return Service(
        Axios.delete(
            `/automacao/regua/deletaretaparegua?idEtapaRegua=${idEtapaRegua}`
        )
    );
}

export async function ListarAcoesReguaPorEtapaService(IdEtapaRegua: number) {
    return Service(
        Axios.get<Array<IAcoesReguaEtapa>>(
            `/automacao/regua/listaacoesreguaporetapa?IdEtapaRegua=${IdEtapaRegua}`
        )
    );
}

export async function GetAcaoReguaService(IdAcaoEtapaRegua: number) {
    return Service(
        Axios.get<IAcoesReguaEtapa>(
            `/automacao/regua/getacaoregua?IdAcaoEtapaRegua=${IdAcaoEtapaRegua}`
        )
    );
}

export async function DeletarAcaoReguaService(IdAcaoEtapaRegua: number) {
    return Service(
        Axios.delete(
            `/automacao/regua/deletaracaoetapa?IdAcaoEtapaRegua=${IdAcaoEtapaRegua}`
        )
    );
}

//Tipo Ação
export async function ListarTiposAcoesReguaService() {
    return Service(
        Axios.get<Array<ITipoAcaoRegua>>(`/automacao/regua/listartipoacaoregua`)
    );
}

//Filtro Ação Etapa
export async function ListarFiltrosAcaoEtapaService(IdAcaoEtapaRegua: number) {
    return Service(
        Axios.get<Array<IReguaEtapaAcaoFiltro>>(
            `/automacao/regua/listarfiltrosacaoetapa?IdAcaoEtapaRegua=${IdAcaoEtapaRegua}`
        )
    );
}

export async function DeletearFiltroAcaoEtapaService(
    IdFiltroAcaoEtapaRegua: number
) {
    return Service(
        Axios.delete(
            `/automacao/regua/deletearfiltroacaoetapa?IdFiltroAcaoEtapaRegua=${IdFiltroAcaoEtapaRegua}`
        )
    );
}

export async function EditarFiltroAcaoEtapaService(
    requestBody: IReguaEtapaAcaoFiltro
) {
    return Service(
        Axios.post(`/automacao/regua/editarfiltroacaoetapa`, requestBody)
    );
}

export async function CadastrarFiltroAcaoEtapaService(
    requestBody: IReguaEtapaAcaoFiltro
) {
    return Service(
        Axios.post(`/automacao/regua/cadastrarfiltroacaoetapa`, requestBody)
    );
}

//Tipo Filtro Ação Etapa
export async function ListarTipoFiltroAcaoEtapaService() {
    return Service(
        Axios.get<Array<IReguaEtapaAcaoTipoFiltro>>(
            `/automacao/regua/listartipofiltrosacaoetapa`
        )
    );
}

//Ordenação da etapa
export async function ListarOrdenacaoEtapaService(idEtapaRegua: number) {
    return Service(
        Axios.get<Array<IOrdenacaoReguaEtapa>>(
            `/automacao/regua/listarordenacaoetapa?idEtapaRegua=${idEtapaRegua}`
        )
    );
}

export async function CadastrarOrdenacaoEtapaServices(
    requestBody: IOrdenacaoReguaEtapa
) {
    return Service(
        Axios.post(`/automacao/regua/cadastrarordenacaoetapa`, requestBody)
    );
}

export async function DeletarOrdenacaoEtapaServices(idEtapaRegua: number) {
    return Service(
        Axios.delete(
            `/automacao/regua/deletarordenacaoetapa?idEtapaRegua=${idEtapaRegua}`
        )
    );
}

//Listar DADOS da etapa
export async function ListarDadosAcoesEtapaServices(
    idReguaEtapaAcao: number,
    dsTipoAcao: string
) {
    return Service(
        Axios.get<Array<IDadosReguaEtapa>>(
            `/automacao/regua/listardadosacoesetapa?idReguaEtapaAcao=${idReguaEtapaAcao}&dsTipoAcao=${dsTipoAcao}`
        )
    );
}

export async function ListarDadosAcoesEtapaBaixarExcelService<Blob>(
    idReguaEtapaAcao: number,
    dsTipoAcao: string,
    flExcel?: boolean
) {
    return Service(
        Axios.get<Blob>(
            `/automacao/regua/listardadosacoesetapa?idReguaEtapaAcao=${idReguaEtapaAcao}&dsTipoAcao=${dsTipoAcao}&flExcel=${flExcel}`,
            { responseType: "blob" }
        )
    );
}

//EXECUTAR REGUA
export async function ExecutarReguaServices(
    requestBody: Array<IDadosReguaEtapa>,
    idReguaEtapaAcao: number
) {
    return Service(
        Axios.post(
            `/automacao/regua/executarregua?idReguaEtapaAcao=${idReguaEtapaAcao}`,
            requestBody
        )
    );
}

//AGENDAMENTO da Ação
export async function GetAgendaAcaoEtapaReguaServices(
    idReguaEtapaAcao: number
) {
    return Service(
        Axios.get<Array<IEtapaAcaoAgendamento>>(
            `/automacao/regua/getagendaacaoetaparegua?idReguaEtapaAcao=${idReguaEtapaAcao}`
        )
    );
}

export async function CadatrarAgendaAcaoEtapaReguaServices(
    requestBody: IEtapaAcaoAgendamento
) {
    return Service(
        Axios.post(
            `/automacao/regua/cadastraragendaacaoetaparegua`,
            requestBody
        )
    );
}

export async function DeletarAgendaAcaoEtapaReguaServices(
    idReguaEtapaAcaoAgenda: number
) {
    return Service(
        Axios.delete(
            `/automacao/regua/deletaragendaacaoetaparegua?idReguaEtapaAcaoAgenda=${idReguaEtapaAcaoAgenda}`
        )
    );
}

export async function CadastrarAcaoEtapaService(
    requestBody: ICadastrarAcaoEtapaBody
) {
    return Service(Axios.post(`/automacao/regua/insereacaoetapa`, requestBody));
}

export async function EditarAcaoEtapaService(
    requestBody: ICadastrarAcaoEtapaBody
) {
    return Service(
        Axios.put(`/automacao/regua/atualizaracaoregua`, requestBody)
    );
}
